"use client";

import { forwardRef } from "react";
import { AppModal } from "./app-modal";

type IframeFullscreenModalProps = {
  open: boolean;
  onClose: () => void;
  backdropLabel: string;
  title: string;
  src: string;
  iframeKey: string;
};

export const IframeFullscreenModal = forwardRef<
  HTMLIFrameElement,
  IframeFullscreenModalProps
>(function IframeFullscreenModal(
  { open, onClose, backdropLabel, title, src, iframeKey },
  ref,
) {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      backdropLabel={backdropLabel}
      ariaLabel={title}
      paddingClassName="p-0"
      zClassName="z-[120]"
    >
      <div className="relative h-[100dvh] w-screen bg-black">
        <iframe
          ref={ref}
          key={iframeKey}
          title={title}
          className="h-full w-full border-0 bg-black"
          src={src}
          allow="autoplay; fullscreen; picture-in-picture"
          loading="eager"
          sandbox="allow-scripts allow-same-origin"
        />
      </div>
    </AppModal>
  );
});
